// @ts-nocheck
// Shared with andre-haikal/eufooria; update with its bridge tests.
(function (window) {
  'use strict';
  var installed = false;
  var pendingKey = 'meta-pending-events';
  var pendingMemory = [];

  function read(key, fallback) {
    try { return JSON.parse(window.sessionStorage.getItem(key)) || fallback; }
    catch (_) { return fallback; }
  }
  function write(key, value) {
    try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) { /* checkout must still work */ }
  }
  function remove(key) {
    try { window.sessionStorage.removeItem(key); } catch (_) { /* storage may be disabled */ }
  }
  function queue(events) {
    var pending = read(pendingKey, []).concat(pendingMemory).filter(function (event, index, all) {
      return all.findIndex(function (item) { return item.event_id === event.event_id; }) === index;
    });
    (events || []).forEach(function (event) {
      if (event && event.event_id && !pending.some(function (item) { return item.event_id === event.event_id; })) pending.push(event);
    });
    pendingMemory = pending;
    write(pendingKey, pending);
    // The bootstrap stub can be discarded by an immediate page redirect.
    // Keep descriptors pending until the real Pixel runtime can accept them.
    if (typeof window.fbq === 'function' && typeof window.fbq.callMethod === 'function') {
      window.MetaTracking.trackEvents(pending);
      pendingMemory = [];
      remove(pendingKey);
    }
  }

  function install(options) {
    if (installed || !window.MetaTracking || typeof window.fetch !== 'function') return;
    var crmOrigin = new URL(options.crmOrigin).origin;
    var checkoutPaths = options.checkoutPaths || [];
    var originalFetch = window.fetch;
    installed = true;
    window.MetaTracking.captureAttribution();

    function target(url) {
      if (url.origin === crmOrigin && url.pathname === '/api/v1/trial_class_registrations') return 'registration';
      if (url.origin === crmOrigin && /^\/api\/v1\/events\/[^/]+\/bookings$/.test(url.pathname)) return 'checkout';
      if (url.origin === window.location.origin && checkoutPaths.indexOf(url.pathname) !== -1) return 'checkout';
      return null;
    }
    function remember(data) {
      // meta_purchase describes an UNPAID checkout. Never send it here.
      queue((data.meta_events || []).filter(function (event) { return event.event_name !== 'Purchase'; }));
      flushAttempts = 0;
      flush();
      if (data.checkout_session_id && data.meta_purchase_token) {
        write('meta-checkout:' + data.checkout_session_id, data.meta_purchase_token);
      }
    }
    window.fetch = function (input, init) {
      var kind, next = init;
      // Existing WordPress widgets and the check-in API client use URL strings.
      // Leave Request objects, non-JSON bodies and unrelated requests untouched.
      try {
        if (typeof input !== 'string' && !(input instanceof URL)) return originalFetch.apply(this, arguments);
        var url = new URL(input, window.location.href);
        kind = target(url);
        if (!kind || !init || String(init.method).toUpperCase() !== 'POST' || typeof init.body !== 'string') {
          return originalFetch.apply(this, arguments);
        }
        var body = JSON.parse(init.body);
        if (!body || Array.isArray(body) || typeof body !== 'object') return originalFetch.apply(this, arguments);
        var context = window.MetaTracking.context();
        if (kind === 'registration' && /^\d+$/.test(String(body.training_period_id))) {
          context.event_source_url = crmOrigin + '/trainings/' + body.training_period_id;
        }
        next = Object.assign({}, init, { body: JSON.stringify(Object.assign({}, body, { meta_tracking: context })) });
      } catch (_) { return originalFetch.apply(this, arguments); }
      return originalFetch.call(this, input, next).then(function (response) {
        if (!response.ok) return response;
        // Wait for descriptors to be saved before the widget can redirect away.
        return response.clone().json().then(function (data) { remember(data); return response; })
          .catch(function () { return response; });
      });
    };

    var flushAttempts = 0;
    function flush() {
      queue([]);
      if (pendingMemory.length && ++flushAttempts < 30) window.setTimeout(flush, 500);
    }
    flush();

    var params = new URLSearchParams(window.location.search);
    var sessionId = params.get('session_id');
    if (!sessionId || params.get('checkout') === 'cancel' || /cancel/.test(window.location.pathname)) return;
    var receiptKey = 'meta-checkout:' + sessionId;
    var token = read(receiptKey, null);
    if (!token) return;
    var attempts = 0;
    function retry() { if (++attempts < 60) window.setTimeout(poll, 1000); }
    function poll() {
      return originalFetch.call(window, crmOrigin + '/api/v1/meta_conversions/purchase', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ checkout_session_id: sessionId, token: token })
      }).then(function (response) {
        if (response.status === 202 || response.status >= 500) { retry(); return; }
        if (response.status === 404) { remove(receiptKey); return; }
        if (!response.ok) return;
        return response.json().then(function (data) {
          queue((data.meta_events || []).filter(function (event) {
            return event.event_name === 'Purchase' && event.event_id === 'purchase-' + sessionId;
          }));
          remove(receiptKey);
          flushAttempts = 0;
          flush();
        });
      }).catch(retry);
    }
    poll();
  }
  window.MetaTrackingBridge = { install: install };
}(window));
